import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { showPreview } from "../../../../../redux/actions/integrationActions";
import Modal, { ModalTransition,ModalBody,ModalFooter, ModalHeader,ModalTitle} from "@atlaskit/modal-dialog";
import Button from '@atlaskit/button/new';
const PreviewAction = () => {
  const dispatch = useDispatch();
  const isVisible = useSelector((state) => state.integration.showPreview);
  const resolvedRequest = useSelector((state) => state.integration.resolvedRequest);
  useEffect(() => {}, [showPreview, resolvedRequest]);
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && isVisible) {
        showPreview(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isVisible]);
  const onClose = () => {
    dispatch(showPreview(false));
  };
 
  return (
    <ModalTransition>
      {isVisible && (
        <Modal actions={[{ text: "Close", onClick: onClose }]} shouldCloseOnOverlayClick={false} width={1000}>
         <ModalHeader>
              <ModalTitle>Preview REST Request</ModalTitle>
            </ModalHeader>
            <ModalBody>
            <p>Method:{resolvedRequest?.method}</p>
            <p>URL: {resolvedRequest?.url}</p>
            <p>Headers:{JSON.stringify(resolvedRequest?.headers)}</p>
            <p>Body: {resolvedRequest?.body}</p>
          </ModalBody>
          <ModalFooter>
              <Button appearance="subtle" onClick={onClose}>
              Close
              </Button>
            </ModalFooter>
          
        </Modal>
      )}
    </ModalTransition>
  );
};
export default PreviewAction;
